import { fetch } from '@/shared/fetch';
import { CaregiverRoleEnum, ConsultationTypeEnum } from '@/shared/enums';

export const fetchVisibleConsultationTypes = async (
    handledBy: CaregiverRoleEnum,
    patientUid: string,
): Promise<ConsultationTypeEnum[] | null> => {
    const query = `?handledBy=${encodeURIComponent(handledBy)}&patientUid=${encodeURIComponent(patientUid)}`;

    return await fetch<ConsultationTypeEnum[] | null>(
        '/api/consultations/visible-consultation-types' + query,
        'GET',
    );
};
